//
//
//
//
//
//

export default {
  name: 'DragNode',
  props: ['target'],
  computed: {
    style() {
      if (undefined === this.target.top) {
        return 'display: none'
      }

      return `top: ${this.target.top}px; left: ${this.target.left}px`
    }
  }
}
